<h3>Header. ALC Amplify authorization component</h3>
<!--<template>-->

<!--// Replaced by standard [Authentication \- Authenticator \- Amplify Docs](https://docs.amplify.aws/ui/auth/authenticator/q/framework/angular)
Login message <p>{{ message }}</p>-->
<amplify-authenticator>
  <div>
    <amplify-sign-out></amplify-sign-out>
  </div>
</amplify-authenticator>
<!--</template>-->
<!--<form>
  <div>
    <label for="email">Email address</label>
    <input type="email" name="email" [(ngModel)]="email" required placeholder="Enter your email">
  </div>
  <div>
    <label for="password">Password</label>
    <input type="password" name="password" [(ngModel)]="password" required id="password"
           placeholder="Enter your password">
  </div>
  <div>
    <br />
    <button (click)="loginWithCognito()" class="btn btn-primary btn-block" type="button"> Log In </button>
  </div>
</form>
<p class="text-dark mb-0">Not a member?<a href="/sign-up" class="text-primary ml-1">Sign Up now</a></p>-->
